import api from './api';

export const paymentService = {
    createPayment: async (paymentData) => {
        try {
            const response = await api.post('/api/payments/create', 
                paymentData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            
            return response.data;
        } catch (error) {
            console.error('Ödeme hatası:', error);
            throw new Error(error.response?.data?.message || 'Ödeme işlemi başarısız oldu');
        }
    },

    getPaymentStatus: async (transactionId) => {
        try {
            const response = await api.get(`/api/payments/${transactionId}`);
            return response.data;
        } catch (error) {
            console.error('Ödeme durumu sorgulama hatası:', error);
            throw error;
        }
    },

    uploadReceipt: async (file, paymentId) => {
        try {
            // FormData oluştur
            const formData = new FormData();
            formData.append('file', file);
            formData.append('paymentId', paymentId);
            
            

            // 1. Adım: Dosya Yükleme
            const uploadResponse = await api.post('/api/files/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // Eğer authentication token kullanıyorsanız:
                    // 'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });


            // Dosya adını al
            let filename;
            if (typeof uploadResponse.data === 'string') {
                filename = uploadResponse.data.replace('Dosya yüklendi: ', '');
            } else if (uploadResponse.data && uploadResponse.data.filename) {
                filename = uploadResponse.data.filename;
            } else {
                throw new Error('Geçersiz dosya yükleme yanıtı');
            }

            // 2. Adım: Payment Kaydını Güncelle
            try {
                await api.post(`/api/payments/${paymentId}/update-receipt`, 
                    { receipt: filename },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            // Eğer authentication token kullanıyorsanız:
                            // 'Authorization': `Bearer ${localStorage.getItem('token')}`
                        }
                    }
                );

                return true; // Başarılı olduğunu belirt
            } catch (updateError) {
                console.error('Error updating payment:', updateError);
                // Dosya yüklendi ama payment güncellenemedi - yine de başarılı sayalım
                return true;
            }

        } catch (error) {
            console.error('Receipt upload error:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
                error: error
            });

            // Eğer dosya yüklendi ama payment güncellenemedi ise başarılı sayalım
            if (error.response?.status === 403) {
                return true; // Dosya yüklendi ama yetki hatası aldık - yine de başarılı sayalım
            }

            throw new Error('Dekont yükleme işlemi başarısız oldu: ' + (error.message || 'Bilinmeyen hata'));
        }
    },

    verifyPayment: async (paymentId, approve) => {
        try {
            const response = await api.post(`/api/payments/${paymentId}/verify?approve=${approve}`);
            return response.data;
        } catch (error) {
            console.error('Payment verification error:', error);
            throw new Error(error.response?.data?.message || 'Payment verification failed');
        }
    },

    getReceiptUrl: async (filename) => {
        // Eğer filename tam path içeriyorsa, sadece filename kısmını al
        const actualFilename = filename.split('/').pop();
        const baseUrl = api.defaults.baseURL.replace(/\/+$/, ''); // Sondaki slash'leri temizle
        return `${baseUrl}/api/files/uploads/${actualFilename}`;
    },

    getAllPayments: async () => {
        try {
            const response = await api.get('/api/payments/getAllPayments');
            return response.data;
        } catch (error) {
            console.error('Ödemeler getirilirken hata:', error);
            throw error;
        }
    },

    getPaymentById: async (id) => {
        try {
            const response = await api.get(`/api/payments/getPaymentById/${id}`);
            return response.data;
        } catch (error) {
            console.error('Ödeme detayı getirilirken hata:', error);
            throw error;
        }
    },

    updatePayment: async (id, paymentData) => {
        try {
            const response = await api.put(`/api/payments/updatePayment/${id}`, paymentData);
            return response.data;
        } catch (error) {
            console.error('Ödeme güncellenirken hata:', error);
            throw error;
        }
    },

    deletePayment: async (id) => {
        try {
            await api.delete(`/api/payments/deletePayment/${id}`);
        } catch (error) {
            console.error('Ödeme silinirken hata:', error);
            throw error;
        }
    }
};  
